import {
  type PosthogExceptionEntry,
  type PosthogExceptionFrame,
  exceptionValue,
} from "./posthog-exception-types";

export function isInjectedBrowserBridgeMessage(value: string): boolean {
  return (
    value.includes("window.webkit.messageHandlers") ||
    value.includes("Invalid call to runtime.sendMessage(). Tab not found") ||
    value.includes(
      "Cannot read properties of undefined (reading 'bufferBelongsToIframe')",
    )
  );
}

export function isNextCurrentScriptInvariantValue(value: string): boolean {
  return value.includes(
    "Expected document.currentScript to be a <script> element",
  );
}

export function isFrozenHistoryAssignmentValue(value: string): boolean {
  return (
    value.includes(
      "Cannot assign to read only property 'pushState' of object '#<History>'",
    ) ||
    value.includes(
      "Cannot assign to read only property 'replaceState' of object '#<History>'",
    )
  );
}

export function isFirefoxIosInjectedGlobalValue(value: string): boolean {
  return value.includes("__firefox__");
}

export function isDuckDuckGoFeatureInjectionValue(value: string): boolean {
  return /feature named ['"`].+?['"`] was not found/i.test(value);
}

function frameLooksThirdParty(frame: PosthogExceptionFrame): boolean {
  if (frame.in_app === false) return true;
  const path = frame.filename ?? frame.abs_path ?? "";
  if (!path) return false;
  return !path.startsWith("app:///") && !path.includes("_next/");
}

export function isDuckDuckGoFeatureInjectionPosthog(
  first: PosthogExceptionEntry,
): boolean {
  if (!isDuckDuckGoFeatureInjectionValue(exceptionValue(first))) return false;
  const frames = first.stacktrace?.frames ?? [];
  if (frames.length === 0) return false;
  return frames.every(frameLooksThirdParty);
}

export function isWebkitAutofillHandlerValue(value: string): boolean {
  return value.includes("_AutofillCallbackHandler");
}
